<div class="tc-cask-selection__container">
    @for (cask of casks; track cask.key) {
        <div class="cask__item__container" (click)="selectCask($event, cask)">
            <span>{{cask.description}}</span>
            <small>{{createBarcode(cask.key.toString(), '69')}}</small>
        </div>
    }
</div>